import { Clear } from '@ori-ui/icons';
import useTestId from '@ori/testid-generator';
import { useCallback } from 'react';
import type { MouseEventHandler, FC } from 'react';

import { useAppPromo } from '../../context';
import { useTranslations } from '../../hooks/useTranslations';
import { AppInfo } from './components';
import { APP_PROMO_BANNER, APP_PROMO_BANNER_CLOSE, APP_PROMO_BANNER_OPEN } from './constants';
import { CloseButton, Inner, OpenButton, Root } from './styles';

export const AppPromoBanner: FC = () => {
  const { translations } = useTranslations();
  const { appDescription, appIcon, appName, bannerLink, className, visible, onClose } = useAppPromo();
  const { getTestId } = useTestId();

  const onCloseButtonClick = useCallback<MouseEventHandler<HTMLDivElement>>(
    (event) => {
      event.preventDefault();
      onClose?.();
    },
    [onClose],
  );

  if (!visible) {
    return null;
  }

  return (
    <Root>
      <Inner
        className={className}
        data-testid={getTestId(APP_PROMO_BANNER)}
        href={bannerLink ?? '#'}
      >
        <CloseButton
          data-testid={getTestId(APP_PROMO_BANNER_CLOSE)}
          onClick={onCloseButtonClick}
        >
          <Clear />
        </CloseButton>
        <AppInfo
          appDescription={appDescription}
          appIcon={appIcon}
          appName={appName}
        />
        <OpenButton
          data-testid={getTestId(APP_PROMO_BANNER_OPEN)}
          variant="button"
        >
          {translations.open}
        </OpenButton>
      </Inner>
    </Root>
  );
};
